import { TranslateService } from '@ngx-translate/core';
import { Pipe, PipeTransform } from '@angular/core';
import { Mentorship } from '../mentoring-api.model';
import { MentorshipContactType } from '../mentoring.enums';

@Pipe({
  name: 'mentoringContact',
})
export class MentoringContactPipe implements PipeTransform {
  public i18n = this.translate.instant([
    'Core_Chat',
    'Core_Email',
    'Core_Meeting',
    'Core_Other',
    'Core_Phone',
  ]);

  public constructor(private translate: TranslateService) {}

  public transform(mentorship: Mentorship): string {
    switch (mentorship.mentorContactMethodId) {
      case MentorshipContactType.Chat: {
        return this.i18n.Core_Chat;
      }
      case MentorshipContactType.Email: {
        return this.i18n.Core_Email;
      }
      case MentorshipContactType.Meeting: {
        return this.i18n.Core_Meeting;
      }
      case MentorshipContactType.Other: {
        return (
          mentorship.mentorContactMethodDescription || this.i18n.Core_Other
        );
      }
      case MentorshipContactType.Phone: {
        return this.i18n.Core_Phone;
      }
      // property is nullable, so!
      default: {
        return '';
      }
    }
  }
}
